import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type GlobalLockerState = {
  showLocker: boolean;
  title: Nullable<string>;
  ariaLabel: Nullable<string>;
};
const initialState: GlobalLockerState = {
  showLocker: false,
  title: null,
  ariaLabel: null,
};

export const globalLockerSlice = createSlice({
  name: 'route',
  initialState,
  reducers: {
    toggleLocker(
      state: GlobalLockerState,
      action: PayloadAction<{ showLocker: boolean; title?: string; ariaLabel?: string }>,
    ) {
      state.showLocker = action.payload.showLocker;
      state.title = action.payload.title;
      state.ariaLabel = action.payload.ariaLabel;
    },
  },
});

export const { toggleLocker } = globalLockerSlice.actions;
export const globalLockerReducer = globalLockerSlice.reducer;
